import es from '../locales/es.js';

/* Solo el español va dentro de la app. Los demás idiomas son ficheros aparte (dist/lang/xx.js, los genera scripts/build.js)
   que se cargan solo si hacen falta: index.html carga el del idioma guardado antes que la app, y al cambiar de idioma en
   Ajustes se pide el nuevo. Así el arranque no analiza seis diccionarios para usar uno. */
const dictionaries = { es };
const LANG_FILES = ['en', 'fr', 'de', 'pt', 'it'];
const pending = {};

const external = () => (typeof window !== 'undefined' && window.__filotecaLangs) || {};
const dict = (code) => dictionaries[code] || external()[code] || null;

/** Añade un diccionario ya cargado (pruebas, panel de administración). */
export function registerLocale(code, d) {
    dictionaries[code] = d;
}

export function hasLocale(code) {
    return !!dict(code);
}

/** Carga el fichero de un idioma si no está. → true si se puede usar; false si no existe o falló (se sigue en español). */
export function loadLocale(code) {
    if (dict(code)) return Promise.resolve(true);
    if (LANG_FILES.indexOf(code) === -1 || typeof document === 'undefined' || !document.head || typeof document.createElement !== 'function') return Promise.resolve(false);
    if (pending[code]) return pending[code];
    pending[code] = new Promise((resolve) => {
        const s = document.createElement('script');
        s.src = 'dist/lang/' + code + '.js';
        s.onload = () => { delete pending[code]; resolve(!!dict(code)); };
        s.onerror = () => { delete pending[code]; resolve(false); };
        document.head.appendChild(s);
    });
    return pending[code];
}

/** Un texto en un idioma concreto (para el panel de administración, que edita todos a la vez). */
export function textIn(lang, key) {
    const d = dict(lang);
    return (d && d[key]) || dictionaries.es[key] || '';
}

export const i18n = {
    lang: 'es',
    available: [
        { code: 'es', name: 'Español' },
        { code: 'en', name: 'English' },
        { code: 'fr', name: 'Français' },
        { code: 'de', name: 'Deutsch' },
        { code: 'pt', name: 'Português' },
        { code: 'it', name: 'Italiano' }
    ],

    detect() {
        const nav = (navigator.language || 'es').slice(0, 2).toLowerCase();
        return this.available.some((a) => a.code === nav) ? nav : 'es';
    },

    setLang(code) {
        this.lang = this.available.some((a) => a.code === code) ? code : this.detect();
        document.documentElement.setAttribute('lang', this.lang);
        // Si el diccionario aún no está (index.html no pudo cargarlo), se pide y se avisa para repintar; mientras, español.
        if (!dict(this.lang)) loadLocale(this.lang).then((ok) => { if (ok && this.onLoaded) this.onLoaded(this.lang); });
        return this.lang;
    },

    /** Lo llama la app cuando llega un diccionario pedido tarde (repinta la interfaz). */
    onLoaded: null,

    t(key, params) {
        const d = dict(this.lang) || dictionaries.es;
        let text = d[key];
        if (text === undefined) text = dictionaries.es[key];
        if (text === undefined) return key;
        if (params) {
            Object.keys(params).forEach((k) => {
                text = text.replace(new RegExp('\\{' + k + '\\}', 'g'), params[k]);
            });
        }
        return text;
    }
};

export function t(key, params) {
    return i18n.t(key, params);
}
